import { DATE_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import dayjs, { Dayjs } from "dayjs";

export const formatDate = (value?: string | null) => {
  if (!value) return EMPTY_STR.DATE;
  const date = dayjs(value);
  return date.isValid() ? date.format(DATE_FORMAT) : EMPTY_STR.DATE;
};

export const toDateOnly = (value?: Dayjs | null) => (value ? dayjs(dayjs(value).format(DATE_FORMAT)) : null);
